import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent {
  logoUrl = '';

  ngOnInit() {
    document.addEventListener('scroll', () => {
      const scrollableHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      if (window.scrollY >= scrollableHeight - 100 && window.scrollY > 150) {
        this.logoUrl = '/assets/logo-reduced.svg';
      } else {
        this.logoUrl = '';
      }
    });
  }
}
